export const iconPickerActionTypes = {
	hide: 'hide',
	show: 'show',
	select: 'select',
	filter: 'filter',
	navigate: 'navigate'
};
